// Copyright (c) Docugami, Inc. All rights reserved.

import { ChatOptions } from "store/chat/chatApi";
import { FeatureFlags } from "store/featureFlags/types";
import { useFeatureFlag } from "./FeatureFlags";
import { useTelemetryContext } from "./TelemetryContext";
import { useMemo } from "react";

export function useChatTelemetryContext(options: ChatOptions | null) {
    const isStreaming = useFeatureFlag(FeatureFlags.ChatStreaming);

    const hasOptions = !!options;
    const context = useMemo(() => hasOptions ? ({
        documentSetId: options.docsetId,
        chatStreaming: isStreaming
    }) : undefined, [hasOptions, options?.docsetId, isStreaming]);

    useTelemetryContext(context);
}
